"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _cookies = require("../../utils/cookies");
var _style = _interopRequireDefault(require("./style.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var PremiumAuditSystemError = /*#__PURE__*/function (_React$Component) {
  function PremiumAuditSystemError(props) {
    var _this;
    _classCallCheck(this, PremiumAuditSystemError);
    _this = _callSuper(this, PremiumAuditSystemError, [props]);
    _this.linkClick = _this.linkClick.bind(_this);
    _this.setAdditionalAttribute = _this.setAdditionalAttribute.bind(_this);
    return _this;
  }
  _inherits(PremiumAuditSystemError, _React$Component);
  return _createClass(PremiumAuditSystemError, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.analytics.track('nav', {
        event_category: 'system tag',
        event_action: 'system verified',
        event_detail: 'Conversion Error Page',
        event_label: 'Conversion Error Page',
        knockout_error_type: 'Application Error',
        knockout_error_description: 'Generic error page',
        appcd: 'conversion-app',
        pii_filter: false
      });
    }
  }, {
    key: "linkClick",
    value: function linkClick(event) {
      this.props.analytics.track('click', {
        event_category: 'page tag',
        event_action: 'link click',
        event_detail: event.target.id,
        event_label: 'premiumauditerror',
        appcd: 'conversion-app',
        pii_filter: false
      });
    }
  }, {
    key: "setAdditionalAttribute",
    value: function setAdditionalAttribute() {
      var userId = this.props.userId;
      var additionalAttribute = {};
      additionalAttribute.userId = userId ? userId : '';
      return additionalAttribute;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "medium-container"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "margin-top-xx-large tds-h1--small"
      }, "We\u2019re sorry."), /*#__PURE__*/React.createElement("p", {
        className: "margin-top-xx-large tds-large"
      }, "MyTravelers is temporarily unavailable."), /*#__PURE__*/React.createElement("div", {
        className: "tds-large"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: this.linkClick,
        id: "CONTINUETOPREMIUMAUDIT",
        href: process.env.PREMIUMAUDIT_URL
      }, "Continue to Premium Audit")), /*#__PURE__*/React.createElement("hr", {
        className: "content-divider margin-top-xx-large shorten-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "margin-top-xx-large"
      }, "If you continue to experience this problem and need to ", /*#__PURE__*/React.createElement("span", {
        className: "tds-bold"
      }, "contact the premium audit team "), "now, please call us at", /*#__PURE__*/React.createElement("span", null, " "), /*#__PURE__*/React.createElement("a", {
        onClick: this.linkClick,
        id: "PREMIUMAUDITPHONENUMBER",
        href: 'tel:+' + process.env.PREMIUMAUDIT_CALLUS_NUM
      }, process.env.PREMIUMAUDIT_CALLUS_NUM), ",  8 AM to 7 PM ET, Monday\u2013Friday."));
    }
  }]);
}(React.Component);
var _default = exports["default"] = PremiumAuditSystemError;